// extracted by mini-css-extract-plugin
module.exports = {"bundleSubtitle":"BundleHeaderPageSegment-BundleSubtitle-module--bundle-subtitle--25fvo"};